/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { CardSection, CardSectionProps } from './CardSection';

const CardHeader: ComponentWithChildren<CardSectionProps> = ({ children, ...props }) => (
  <CardSection direction="horizontal" addLineSeperator {...props}>
    {children}
  </CardSection>
);

export default CardHeader;
